import { brand } from '../../../theme/themePrimitives';
import { CheckCircleOutlineOutlined } from '@mui/icons-material';
import CustomModal from '../../modals';
import { Box, Typography } from '@mui/material';


const ImportedReviewsModal = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
    return <CustomModal open={open} handleClose={onClose} isSuccess={true} title="Reviews Imported">
        <Box display="flex" flexDirection="column" alignItems="center" gap={1}>
            <CheckCircleOutlineOutlined sx={{ fontSize: 100, color: brand[300] }} />
            <Typography variant="subtitle1" fontWeight="bold" mt={2} sx={{ color: brand[300] }}>
                Your reviews are being imported.
            </Typography>
            <Typography variant="subtitle2" sx={{ color: brand[300] }}>
                Please allow several minutes for them to show here.
            </Typography>
        </Box>
    </CustomModal>;
};

export default ImportedReviewsModal;